<script>
import Payment from "$vueCommon/components/Cart/Payment.vue";
import CheckoutAPI from "$vueCommon/classes/API/CheckoutAPI.js";
import bus from "vue3-eventbus";
import {ToastMessageDanger} from "$vueCommon/classes/ToastMessage.js";

export default {
    components: {Payment},
    emits: ['onSelected'],
    props: {
        methods: Array,
        total: Number,
        subtotal: Number,
        errors: Array
    },
    data() {
        return {
            saving: false
        }
    },
    methods: {
        onSelected(paymentMethodSlug) {
            this.methods.forEach(payment => payment.saving = (payment.slug === paymentMethodSlug));
            CheckoutAPI.postPaymentMethod(paymentMethodSlug).then(
                response => {
                    this.methods.forEach(payment => {
                        payment.selected = (payment.slug === paymentMethodSlug);
                        payment.saving = false;
                    });

                    bus.emit('refreshCart', {data: response});
                },
                errorResponse => {
                    this.methods.forEach(payment => payment.saving = false);
                    if (errorResponse.response && errorResponse.response.data && errorResponse.response.data.message) {
                        ToastMessageDanger.emit(errorResponse.response.data.message, 100000);
                    }
                }
            );
        }
    }
}
</script>
<template>
    <div class="component-payments">
        <h2 class="h4">{{ $translate('checkout.payment_method') }}</h2>
        <div :class="{'is-invalid': errors && errors.length > 0}">
            <Payment
                v-for="method in methods"
                :method="method"
                :total="total"
                :subtotal="subtotal"
                @onSelected="onSelected"
            />
        </div>
        <div class="invalid-feedback text-start">
            <small v-for="error in errors" v-html="error"></small>
        </div>
    </div>
</template>
